var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlacedIconsGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200.595,
    height: 137.494,
    viewBox: "0 0 200.595 137.494",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8979",
    "data-name": "Group 8979",
    transform: "translate(-999.867 -106.494)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8949",
    "data-name": "Group 8949",
    transform: "translate(0 -62)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8948",
    "data-name": "Group 8948",
    transform: "translate(87.354 -270.275) rotate(14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1238",
    "data-name": "Rectangle 1238",
    width: 94.93,
    height: 83.702,
    rx: 10.144,
    transform: "translate(1096.818 178.733)",
    fill: "#16d696"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8947",
    "data-name": "Group 8947"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1237",
    "data-name": "Rectangle 1237",
    width: 109.628,
    height: 109.628,
    rx: 10.144,
    transform: "translate(999.867 196.359)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8961",
    "data-name": "Group 8961",
    transform: "translate(1023.245 157.543)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8958",
    "data-name": "Group 8958",
    transform: "translate(8.128 28.148)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7355",
    "data-name": "Path 7355",
    d: "M6.98,41.994V28.468h46.4V41.995",
    transform: "translate(-6.98 -22.333)",
    fill: "none",
    stroke: "#040227",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7356",
    "data-name": "Path 7356",
    d: "M26,23.438V42.963",
    transform: "translate(-2.8 -23.438)",
    fill: "none",
    stroke: "#040227",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_121",
    "data-name": "Ellipse 121",
    cx: 13.074,
    cy: 13.074,
    r: 13.074,
    transform: "translate(18.255 2)",
    fill: "none",
    stroke: "#040227",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7357",
    "data-name": "Path 7357",
    d: "M18.657,21.3a11.282,11.282,0,0,1,8.964-4.428,11.142,11.142,0,0,1,8.949,4.454",
    transform: "translate(3.714 3.268)",
    fill: "none",
    stroke: "#040227",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_122",
    "data-name": "Ellipse 122",
    cx: 3.629,
    cy: 3.629,
    r: 3.629,
    transform: "translate(27.698 7.816)",
    fill: "none",
    stroke: "#040227",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7358",
    "data-name": "Path 7358",
    d: "M39.8,39.557H52.539V52.295H39.8Z",
    transform: "translate(8.36 8.252)",
    fill: "none",
    stroke: "#040227",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7359",
    "data-name": "Path 7359",
    d: "M20.779,39.557H33.514V52.295H20.78Z",
    transform: "translate(4.18 8.252)",
    fill: "none",
    stroke: "#040227",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7360",
    "data-name": "Path 7360",
    d: "M1.755,39.557H14.491V52.295H1.755Z",
    transform: "translate(0 8.252)",
    fill: "none",
    stroke: "#040227",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8960",
    "data-name": "Group 8960",
    transform: "translate(1.755 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8959",
    "data-name": "Group 8959",
    transform: "translate(6.373 26.148)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7361",
    "data-name": "Path 7361",
    d: "M6.98,41.994V28.468h46.4V41.995",
    transform: "translate(-6.98 -22.333)",
    fill: "none",
    stroke: "#040227",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7362",
    "data-name": "Path 7362",
    d: "M26,23.438V42.963",
    transform: "translate(-2.8 -23.438)",
    fill: "none",
    stroke: "#040227",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_123",
    "data-name": "Ellipse 123",
    cx: 13.074,
    cy: 13.074,
    r: 13.074,
    transform: "translate(16.5)",
    fill: "none",
    stroke: "#040227",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7363",
    "data-name": "Path 7363",
    d: "M18.657,21.3a11.282,11.282,0,0,1,8.964-4.428,11.142,11.142,0,0,1,8.949,4.454",
    transform: "translate(1.959 1.268)",
    fill: "none",
    stroke: "#040227",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_124",
    "data-name": "Ellipse 124",
    cx: 3.629,
    cy: 3.629,
    r: 3.629,
    transform: "translate(25.943 5.816)",
    fill: "none",
    stroke: "#040227",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7364",
    "data-name": "Path 7364",
    d: "M39.8,39.557H52.539V52.295H39.8Z",
    transform: "translate(6.605 6.252)",
    fill: "none",
    stroke: "#040227",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7365",
    "data-name": "Path 7365",
    d: "M20.779,39.557H33.514V52.295H20.78Z",
    transform: "translate(2.425 6.252)",
    fill: "none",
    stroke: "#040227",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7366",
    "data-name": "Path 7366",
    d: "M1.755,39.557H14.491V52.295H1.755Z",
    transform: "translate(-1.755 6.252)",
    fill: "none",
    stroke: "#040227",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8962",
    "data-name": "Group 8962",
    transform: "translate(1128.606 132.891) rotate(14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7367",
    "data-name": "Path 7367",
    d: "M40.944,1.646a.869.869,0,0,0-.453-.453A18.179,18.179,0,0,0,21.17,5.377a44.943,44.943,0,0,0-4.719,5.666l-2-.461a8.9,8.9,0,0,0-8.334,2.38L.656,18.43a2.387,2.387,0,0,0,1.5,4.068l7.692.618c-.338.9-.626,1.779-.791,2.364a2.677,2.677,0,0,0,.033,1.548,7.977,7.977,0,0,0-3.377,1.787c-1.581,1.573-2.989,8.466-3.253,9.833a.875.875,0,0,0,1.029,1.029c1.367-.272,8.26-1.68,9.833-3.253a8.033,8.033,0,0,0,1.8-3.377,2.685,2.685,0,0,0,1.548.025h.008c.585-.165,1.441-.436,2.355-.791l.618,7.692a2.39,2.39,0,0,0,4.068,1.5L29.183,36a8.869,8.869,0,0,0,2.38-8.334l-.461-2a44.942,44.942,0,0,0,5.666-4.719C45.432,12.295,40.993,1.753,40.944,1.646ZM1.907,19.674l5.46-5.468a7.1,7.1,0,0,1,6.687-1.911l1.326.3a58.769,58.769,0,0,0-4.834,8.8l-8.252-.659A.628.628,0,0,1,1.907,19.674ZM12.078,35.189c-.766.766-4.562,1.828-7.626,2.5.667-3.072,1.729-6.86,2.5-7.626a6.545,6.545,0,0,1,3.237-1.491l3.377,3.377c-.008.033-.008.066-.016.107A6.809,6.809,0,0,1,12.078,35.189Zm3.162-4.06L11.008,26.9a.988.988,0,0,1-.255-.947c.074-.255.214-.733.4-1.268l6.308,6.308c-.379.132-.881.288-1.268.4A.955.955,0,0,1,15.241,31.129Zm14.6-3.047a7.126,7.126,0,0,1-1.911,6.687l-5.468,5.468a.629.629,0,0,1-1.071-.387L20.734,31.6a58.037,58.037,0,0,0,8.8-4.834ZM19.26,30.306l-7.437-7.437A53.8,53.8,0,0,1,22.406,6.621,16.075,16.075,0,0,1,39.453,2.676a16.312,16.312,0,0,1-3.945,17.056A53.613,53.613,0,0,1,19.26,30.306Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7368",
    "data-name": "Path 7368",
    d: "M292.848,75.648a6.056,6.056,0,1,0,8.565,0A6.059,6.059,0,0,0,292.848,75.648Zm7.321,7.321a4.3,4.3,0,1,1,0-6.078A4.295,4.295,0,0,1,300.169,82.969Z",
    transform: "translate(-267.148 -67.775)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlacedIconsGroup);
export default __webpack_public_path__ + "static/media/placed-icons-group.42864a8a51ca7f53a8fd6a5f098f8e50.svg";
export { ForwardRef as ReactComponent };